import React from 'react';
import { features } from '../mock';
import { Sliders, Drum, Video, Heart, Smartphone, Volume2 } from 'lucide-react';

const iconMap = { Sliders, Drum, Video, Heart, Smartphone, Volume2 };

export default function About() {
  return (
    <section id="about" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 grid-bg-fine opacity-40" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] rounded-full bg-violet-800/5 blur-[140px] pointer-events-none" />

      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="flex items-center gap-3 font-mono text-[11px] tracking-[0.3em] text-cyan-300/80 uppercase mb-6">
          <span className="h-px w-10 bg-cyan-400/50" />
          <span>// The Artist</span>
          <span className="text-white/25">[section.02]</span>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 items-start mb-20">
          <h2 className="font-display text-6xl md:text-7xl lg:text-8xl leading-[0.9]">
            <span className="block text-white">SCORPION</span>
            <span className="block text-gradient-purple italic">SOUL</span>
            <span className="block text-gradient-cyan">MUMBAI</span>
          </h2>
          <div className="pt-4 border-l-2 border-cyan-400/50 pl-6">
            <div className="font-mono text-[10px] tracking-[0.25em] text-cyan-300/60 mb-3">// artist_profile.json</div>
            <p className="text-white/75 text-base md:text-lg leading-relaxed">
              DJ YKAS is Mumbai's open-format force. A{' '}
              <span className="text-cyan-200 font-medium">Corporate Leader by Day and Beatmaker by Night</span>, his sets are a collision of Bollywood nostalgia, Afro heat, percussive live energy, and immersive live graphics. Every performance is a full sensory journey — not just a playlist.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {features.map((f, i) => {
            const Icon = iconMap[f.icon];
            const isEven = i % 2 === 0;
            return (
              <div key={f.title} className="card-glow group relative p-6 md:p-7 border border-violet-500/15 bg-gradient-to-b from-violet-950/25 to-transparent rounded-sm overflow-hidden">
                <div className={`absolute -top-16 -right-16 w-48 h-48 rounded-full blur-[70px] opacity-0 group-hover:opacity-100 transition-opacity ${isEven ? 'bg-cyan-500/15' : 'bg-violet-500/15'}`} />
                <div className="relative">
                  <div className="flex items-center justify-between mb-5">
                    <div className={`w-11 h-11 rounded-sm flex items-center justify-center border ${isEven ? 'bg-cyan-500/10 border-cyan-400/40' : 'bg-violet-500/10 border-violet-400/40'}`}>
                      <Icon className={`w-5 h-5 ${isEven ? 'text-cyan-300' : 'text-violet-300'}`} />
                    </div>
                    <span className={`font-mono text-[10px] tracking-[0.2em] ${isEven ? 'text-cyan-300/60' : 'text-violet-300/60'}`}>{f.code}</span>
                  </div>
                  <h3 className="font-display text-xl tracking-wider text-white mb-3">{f.title}</h3>
                  <p className="text-sm text-white/55 leading-relaxed">{f.desc}</p>
                  <div className="mt-5 pt-4 border-t border-white/5 flex items-center justify-between font-mono text-[9px] tracking-[0.2em] text-white/30">
                    <span>STATUS:ACTIVE</span>
                    <span className={`${isEven ? 'text-cyan-300' : 'text-violet-300'}`}>&gt;_</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
